import React, { SVGProps } from "react";

const SvgEditText = (props) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.45626 1.68357C7.30586 1.67089 7.15373 1.66439 6.99999 1.66439C4.05447 1.66439 1.66666 4.05221 1.66666 6.99772C1.66666 9.94325 4.05447 12.3311 6.99999 12.3311C9.94553 12.3311 12.3333 9.94325 12.3333 6.99772C12.3333 6.84405 12.3268 6.69185 12.3141 6.54145C12.2664 5.97632 12.1302 5.42939 11.912 4.91555L12.9121 3.91401C13.1354 4.3412 13.3137 4.79559 13.4409 5.27091C13.5475 5.67079 13.6172 6.08139 13.6482 6.49859C13.6605 6.66339 13.6667 6.82985 13.6667 6.99772C13.6667 10.6797 10.6819 13.6644 6.99999 13.6644C3.31809 13.6644 0.333328 10.6797 0.333328 6.99772C0.333328 3.31583 3.31809 0.331055 6.99999 0.331055C7.16786 0.331055 7.33433 0.337261 7.49913 0.349461C7.91633 0.380461 8.32693 0.450201 8.72653 0.557121C9.20213 0.683981 9.65653 0.862315 10.0837 1.08559L9.08313 2.08615C8.56833 1.86754 8.02139 1.7313 7.45626 1.68357ZM12.6569 0.398061L13.5997 1.34087L7.47139 7.46912L6.53026 7.47079L6.52859 6.52632L12.6569 0.398061Z"
        fill="black"
      />
    </svg>
  );
};

export default SvgEditText;
